export const ADMINUSER_REQUEST = "ADMINUSER_REQUEST";
export const ADMINUSER_SUCCESS = "ADMINUSER_SUCCESS";
export const ADMINUSER_FAILURE = "ADMINUSER_FAILURE";